const STORAGE_KEY = 'lendingThemeMode'
const MODES = ['auto', 'light', 'dark']

export function getStoredThemeMode() {
  const mode = localStorage.getItem(STORAGE_KEY)
  return MODES.includes(mode) ? mode : 'auto'
}

export function resolveTheme(mode) {
  if (mode === 'light' || mode === 'dark') return mode
  if (typeof window !== 'undefined' && window.matchMedia) {
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
  }
  // 无 matchMedia 时按本地时间兜底：7:00-19:00 白天
  const hour = new Date().getHours()
  return hour >= 7 && hour < 19 ? 'light' : 'dark'
}

export function applyLendingTheme(resolved) {
  if (typeof document === 'undefined') return
  document.documentElement.setAttribute('data-lending-theme', resolved)
}

export function persistThemeMode(mode) {
  localStorage.setItem(STORAGE_KEY, mode)
}

export function nextThemeMode(mode) {
  const idx = MODES.indexOf(mode)
  return MODES[(idx + 1) % MODES.length]
}

export { MODES, STORAGE_KEY }
